"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var items = [
    { form_id: "application", title: "Application" },
    { form_id: "signature_certificate", title: "Signature Certificate" }
];
var IndexPage = (function (_super) {
    __extends(IndexPage, _super);
    function IndexPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IndexPage.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h1", null, "Forms:"),
            items.map(function (item, index) {
                return (React.createElement(Li, { title: item.title, form_id: item.form_id, index: index, key: index }));
            })));
    };
    return IndexPage;
}(react_1.Component));
exports.IndexPage = IndexPage;
function Li(_a) {
    var index = _a.index, form_id = _a.form_id, title = _a.title;
    var url = "/?form_id=" + form_id;
    var pdf_url = url + "&pdf";
    return (React.createElement("div", { style: { marginBottom: "10px" } },
        React.createElement("strong", null,
            index + 1,
            ". "),
        React.createElement("a", { href: url }, title),
        " (",
        React.createElement("a", { href: pdf_url }, "PDF"),
        ")"));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5kZXhQYWdlLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvSW5kZXhQYWdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUkvQixJQUFNLEtBQUssR0FBRztJQUNWLEVBQUMsT0FBTyxFQUFFLGFBQWEsRUFBRSxLQUFLLEVBQUUsYUFBYSxFQUFDO0lBQzlDLEVBQUMsT0FBTyxFQUFFLHVCQUF1QixFQUFFLEtBQUssRUFBRSx1QkFBdUIsRUFBQztDQUNyRSxDQUFBO0FBRUQ7SUFBK0IsNkJBQW9CO0lBQW5EOztJQWFBLENBQUM7SUFaVSwwQkFBTSxHQUFiO1FBQ0ksT0FBTyxDQUNIO1lBQ0kseUNBQWU7WUFDZCxLQUFLLENBQUMsR0FBRyxDQUFDLFVBQUMsSUFBSSxFQUFFLEtBQUs7Z0JBQ25CLE9BQU8sQ0FDSCxvQkFBQyxFQUFFLElBQUMsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLLEVBQUUsT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxHQUFHLEVBQUUsS0FBSyxHQUFJLENBQzdFLENBQUE7WUFDTCxDQUFDLENBQUMsQ0FDQSxDQUNULENBQUE7SUFDTCxDQUFDO0lBQ0wsZ0JBQUM7QUFBRCxDQUFDLEFBYkQsQ0FBK0IsaUJBQVMsR0FhdkM7QUFiWSw4QkFBUztBQWV0QixTQUFTLEVBQUUsQ0FBQyxFQUF3RTtRQUF2RSxnQkFBSyxFQUFFLG9CQUFPLEVBQUUsZ0JBQUs7SUFDOUIsSUFBTSxHQUFHLEdBQUcsZUFBYSxPQUFTLENBQUE7SUFDbEMsSUFBTSxPQUFPLEdBQU0sR0FBRyxTQUFNLENBQUE7SUFDNUIsT0FBTyxDQUNILDZCQUFLLEtBQUssRUFBRSxFQUFDLFlBQVksRUFBRSxNQUFNLEVBQUM7UUFDOUI7WUFBUyxLQUFLLEdBQUcsQ0FBQztpQkFBWTtRQUM5QiwyQkFBRyxJQUFJLEVBQUUsR0FBRyxJQUFHLEtBQUssQ0FBSzs7UUFBRSwyQkFBRyxJQUFJLEVBQUUsT0FBTyxVQUFTO1lBQ2xELENBQ1QsQ0FBQTtBQUNMLENBQUMifQ==